/* eslint:disable */
/**
 * @file Source code generated by gulp-resjson.
 * @version 1.0
 */
export interface Strings {
    MsftSmeShell: {
        Core: {
            Error: {
                ArgumentNullError: {
                    message: string;
                };
                ArgumentError: {
                    message: string;
                };
                UnknownBrowser: {
                    message: string;
                };
                GatewayNameRequired: {
                    message: string;
                };
                NoResponseError: {
                    message: string;
                };
                NoCode: {
                    message: string;
                };
                PowerShellUnableSessionClose: {
                    message: string;
                };
                PowerShellUnableCancelCommand: {
                    message: string;
                };
                QueryCacheFetchOrder: {
                    message: string;
                };
                QueryCacheFetchErrorOnce: {
                    message: string;
                };
                QueryCacheRefreshOrder: {
                    message: string;
                };
                QueryCacheRefreshErrorOnce: {
                    message: string;
                };
                QueryCacheRecoverNoCachedResource: {
                    message: string;
                };
                QueryCacheRecoverMissingRecoveryOption: {
                    message: string;
                };
                ResourceCacheUnableFind: {
                    message: string;
                };
                LoggingUnableSubmit: {
                    message: string;
                };
                EnvironmentNotInitialized: {
                    message: string;
                };
                EnvironmentMissingDefault: {
                    message: string;
                };
                NotificationRpcInitialization: {
                    message: string;
                };
                NotificationUnsupportedState: {
                    message: string;
                };
                NotificationEmptyMessage: {
                    message: string;
                };
                NotificationNoWorkItemFound: {
                    message: string;
                };
                NotificationUnexpectedReceived: {
                    message: string;
                };
                NotificationWebsocketInitialize: {
                    message: string;
                };
                NotificationNoIdFound: {
                    message: string;
                };
                RpcTypeNoMatch: {
                    message: string;
                };
                RpcNotFoundModule: {
                    message: string;
                };
                RpcTargetWindowNotConfigured: {
                    message: string;
                };
                RpcExpiredRetry: {
                    message: string;
                };
                RpcExpired: {
                    message: string;
                };
                RpcSignatureError: {
                    message: string;
                };
                RpcUnexpectedDestination: {
                    message: string;
                };
                RpcUnexpectedEvent: {
                    message: string;
                };
                RpcUnexpectedSequence: {
                    message: string;
                };
                RpcUnexpectedErrorSequence: {
                    message: string;
                };
                RpcNotInitialized: {
                    message: string;
                };
                RpcNotFountInbound: {
                    message: string;
                };
                RpcTimeout: {
                    message: string;
                };
                AddNativeErrorCode: {
                    message: string;
                };
                RpcSubjectClosed: {
                    message: string;
                };
                RpcNotRegisteredHandler: {
                    message: string;
                };
                RpcFailedFindModuleManifest: {
                    message: string;
                };
                ForwarderIdConflict: {
                    message: string;
                };
                ForwarderIdNotFound: {
                    message: string;
                };
                ForwarderUnknownType: {
                    message: string;
                };
                InvalidValue: {
                    message: string;
                };
                ServerListRetrieve: {
                    message: string;
                };
                ServerListFailedSave: {
                    message: string;
                };
                ConnectionStream: {
                    message: string;
                };
                ExpectedSingleNode: {
                    message: string;
                };
                ExpectedClusterNode: {
                    message: string;
                };
                BatchConnection: {
                    message: string;
                };
                BatchResponseParsing: {
                    message: string;
                };
                BatchUnSupportedInvocation: {
                    message: string;
                };
                GatewayUrlNotConfigured: {
                    message: string;
                };
                GatewayUrlMalformed: {
                    message: string;
                };
                ToolValidationResult: {
                    message: string;
                };
                ToolValidationUnsupportedOperator: {
                    message: string;
                };
                ToolValidationUnsupportedDataType: {
                    message: string;
                };
                ToolValidationVersionFormat: {
                    message: string;
                };
                ToolValidationInventoryError: {
                    title: string;
                    message: string;
                };
                ToolValidationGatewayInventoryError: {
                    title: string;
                    message: string;
                };
                PowerShellRunCommandFormat: {
                    message: string;
                };
                PrefixFormat: {
                    message: string;
                };
                Details: {
                    text: string;
                };
            };
            ErrorCode: {
                    Code0: {
                        message: string;
                    };
                    Code5: {
                        message: string;
                    };
                    Code50: {
                        message: string;
                    };
                    Code87: {
                        message: string;
                    };
                    Code110: {
                        message: string;
                    };
                    Code1323: {
                        message: string;
                    };
                    Code1326: {
                        message: string;
                    };
                    Code1355: {
                        message: string;
                    };
                    Code2224: {
                        message: string;
                    };
                    Code2691: {
                        message: string;
                    };
                    Code2692: {
                        message: string;
                    };
                    Code8004108: {
                        message: string;
                    };
                    Translated: {
                        message: string;
                    };
                    Generic: {
                        message: string;
                    };
            };
            ErrorFormat: {
                        Single: {
                            message: string;
                            Details: {
                                message: string;
                            };
                        };
                        Multiple: {
                            message: string;
                                Details: {
                                    message: string;
                                };
                        };
            };
            Units: {
                            MediaConversionFormat: {
                                message: string;
                            };
                            MediaConversionUnknownFormat: {
                                message: string;
                            };
                            MediaConversionB: {
                                label: string;
                            };
                            MediaConversionKB: {
                                label: string;
                            };
                            MediaConversionMB: {
                                label: string;
                            };
                            MediaConversionGB: {
                                label: string;
                            };
                            MediaConversionTB: {
                                label: string;
                            };
                            MediaConversionPT: {
                                label: string;
                            };
                            MediaConversionXB: {
                                label: string;
                            };
                            MediaConversionZB: {
                                label: string;
                            };
                            MediaConversionYB: {
                                label: string;
                            };
                            PercentageConversionPercentFormat: {
                                message: string;
                            };
                            PercentageConversionUnknownFormat: {
                                message: string;
                            };
            };
            Connection: {
                                NoConnection: {
                                    label: string;
                                    message: string;
                                };
                                NoStatusProvider: {
                                    label: string;
                                    message: string;
                                };
                                ErrorState: {
                                    label: string;
                                };
                                FatalState: {
                                    label: string;
                                };
                                OnlineState: {
                                    label: string;
                                };
                                fqdn: {
                                    foundFormat: string;
                                };
                                NeedsAuthorizationState: {
                                    label: string;
                                };
                                UnknownState: {
                                    label: string;
                                    description: string;
                                };
                                WarningState: {
                                    label: string;
                                };
                                ErrorNodeName: {
                                    message: string;
                                };
                                ErrorGatewayUrl: {
                                    message: string;
                                };
                                ErrorService: {
                                    message: string;
                                };
                                ErrorWorker: {
                                    message: string;
                                };
            };
            DirectoryList: {
                                    Upload: {
                                        Error: {
                                            FileNotFound: string;
                                            OperationBlocked: string;
                                            Unknown: string;
                                            UnknownNoMessage: string;
                                        };
                                    };
            };
            WebsocketStream: {
                                        Common: {
                                            ConnectionRetiesError: {
                                                message: string;
                                            };
                                            HandlerRegistrationError: {
                                                message: string;
                                            };
                                            CommunicationError: {
                                                message: string;
                                            };
                                            CommunicationErrorDetail: {
                                                message: string;
                                            };
                                        };
                                        CimStream: {
                                                ResetError: {
                                                    message: string;
                                                };
                                                NoContentError: {
                                                    message: string;
                                                };
                                                UnexpectedReceivedError: {
                                                    message: string;
                                                };
                                                UnexpectedMultipleError: {
                                                    message: string;
                                                };
                                                ConnectionError: {
                                                    message: string;
                                                };
                                        };
                                        PowerShellStream: {
                                                    ResetError: {
                                                        message: string;
                                                    };
                                                    NoContentError: {
                                                        message: string;
                                                    };
                                                    UnexpectedReceivedError: {
                                                        message: string;
                                                    };
                                                    ConnectionError: {
                                                        message: string;
                                                    };
                                        };
                                        SshStream: {
                                                        ResetError: {
                                                            message: string;
                                                        };
                                                        NoContentError: {
                                                            message: string;
                                                        };
                                                        UnexpectedReceivedError: {
                                                            message: string;
                                                        };
                                                        ConnectionError: {
                                                            message: string;
                                                        };
                                                        UpdateError: {
                                                            message: string;
                                                        };
                                        };
            };
            Rpc: {
                                            Version: {
                                                message: string;
                                            };
                                            MissingVersion: {
                                                message: string;
                                            };
                                            Azure: {
                                                        Unexpected: {
                                                            Error: {
                                                                message: string;
                                                            };
                                                        };
                                            };
            };
            Decorators: {
                                                Deprecated: {
                                                    messageFormat: string;
                                                    alternateSignatureFormat: string;
                                                    CssClass: {
                                                        messageFormat: string;
                                                    };
                                                };
                                                Obsolete: {
                                                    messageFormat: string;
                                                    alternateSignatureFormat: string;
                                                };
            };
            Errors: {
                                                    UserProfile: {
                                                        Get: {
                                                            formatMessage: string;
                                                        };
                                                    };
            };
            ScheduleReboot: {
                                                        Restart: {
                                                            Inprogress: {
                                                                Title: string;
                                                                Message: string;
                                                            };
                                                            Success: {
                                                                Title: string;
                                                                Message: string;
                                                            };
                                                            Fail: {
                                                                Title: string;
                                                                Message: string;
                                                            };
                                                        };
                                                        Schedule: {
                                                                Success: {
                                                                    Title: string;
                                                                    Message: string;
                                                                };
                                                                Fail: {
                                                                    Title: string;
                                                                    Message: string;
                                                                };
                                                        };
                                                        Confirmation: {
                                                            Title: string;
                                                            Message: string;
                                                        };
                                                        Error: {
                                                            NoRestartOptions: string;
                                                        };
                                                        Info: {
                                                            CancellingReboot: string;
                                                        };
            };
            CredSSPManager: {
                                                            TryGatewayLocalPowerShellConfigNotConfirmed: {
                                                                error: string;
                                                            };
            };
            TranslateGatewayUrls: {
                                                                Url: {
                                                                    Not: {
                                                                        expected: {
                                                                            ErrorMessage: string;
                                                                        };
                                                                    };
                                                                };
            };
        };
    };
};
